import React from 'react';
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="mt-auto" id='footer'>
      <footer className="border-t border-gray-200 py-8">
        <div className="container mx-auto text-center">
          <nav className="mb-8">
            <ul className="flex justify-center space-x-8 text-gray-600">
              <li><a href="#about" className="hover:text-gray-800">About Us</a></li>
              <li><Link to="/terms-conditions" className="hover:text-gray-800">Terms & Conditions</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-gray-800">Privacy Policy</Link></li>
              <li><a href="#faqs" className="hover:text-gray-800">FAQs</a></li>
            </ul>
          </nav>
          <hr className="border-gray-200 mb-8" />
          <p className="text-gray-600">&copy; 2013-{String(currentYear).slice(-2)} Headway Business Solution LLP</p>
        </div>
      </footer>
    </div>
  )
}

export default Footer;